export default "__VITE_ASSET__CXa7D_3w__"